<template>
  <footer :class="`theme-footer-seven dark-bg`">
    <div class="lg-container">
    

      <div class="container">
        <div class="bottom-footer">
          <div class="row">
            <div class="col-lg-4 order-lg-1 mb-20">
              <ul class="d-flex justify-content-center justify-content-lg-start footer-nav">
                <li><a href="#">Privacy & Terms.</a></li>
                <li><a href="#">Contact Us</a></li>
                <li><a href="/Eu-funding">EU funding </a></li>
       

              </ul>
            </div>
            <div class="col-lg-4 order-lg-3 mb-20">
              <ul class="d-flex justify-content-center justify-content-lg-end social-icon">
                <li><a href="/Eu-funding"><img
                       :src="require(`@/assets/images/blog/eu.avif`)"
                        alt="EU Flag"
                        style="height: 80px; margin-left: 30px;"
                    /> </a></li>
                <li><a href="https://www.instagram.com/roboquark?igsh=ZWI2YzEzYmMxYg=="><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                <li><a href="https://www.linkedin.com/company/roboquark/"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
              </ul>
            </div>
            <div class="col-lg-4 order-lg-2 mb-20">
              <p class="copyright text-center">Copyright @2024  RoboQuark.</p>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- /.lg-container -->

  </footer>
</template>

<script>
export default {
  name: 'FooterSeven',
  props:{
    dark_btn:Boolean,
    dark_bg:Boolean,
  },
  methods: {
    onSubmit() {
      console.log('Submitted');
    },
  },
}
</script>